module.exports = __webpack_public_path__ + "static/media/icon.f906b61c.png";